import CardContainer from "../Card/CardContainer";
import { currencyFormat } from "../helpers";
import { user_add_icon, youth_usbc_icon } from "../icons";

function MembershipProductOptions({
    products = [],
    onProductClick,
    showClickText = true,
    getIcon
}) {
    const hasYouthProduct = products.some(p => p.isYouthProduct);

  function getProductDescription(product) {
        const descriptions = [];

        if (product.isSpecialOlympics) {
            descriptions.push("A Special Olympics Membership may be purchased for this league if the adult bowler has Special Needs. If that applies, please continue.");
        }else if (hasYouthProduct && !product.isYouthProduct) {
            if(product.isAdultBasicProduct){
                 descriptions.push("An Adult Basic Membership for a bowler turning 18 this season may be purchased instead of a youth membership.");
            }else{
                descriptions.push("An Adult Membership for a bowler turning 18 this season may be purchased instead of a youth membership.");
            }
        }
        
        if (product.isAdultBasicProduct) {
            descriptions.push("Valid for one short-season league (16 weeks or less). Choose Adult Standard if you plan to bowl in multiple leagues.");
        }

        return (
            <>
                {descriptions.map((text, index) => (
                    <p key={index} className="card-text">
                        {text}
                    </p>
                ))}

                {hasYouthProduct && !product.isYouthProduct && (
                    <p className="card-text">
                        Once you purchase an adult membership, you cannot buy a youth membership.
                    </p>
                )}
            </>
        );
    }

    return (
        <>
            {products.map(product => (
                <div
                    key={product.id}
                    className={onProductClick ? "card-radio mb-2 text-start" : "mb-2 text-start"}
                    onClick={() => onProductClick?.(product)}
                >
                    <CardContainer
                         icon={getIcon? getIcon(product)
                                : product.isYouthProduct
                                    ? youth_usbc_icon
                                    : user_add_icon
                            }
                    >
                        <h5 className="card-title">
                            <strong>{product.name}</strong>
                            <div>
                                <strong className="card-text">
                                    - add {currencyFormat(product.cost)}
                                </strong>
                            </div>
                        </h5>

                        {getProductDescription(product)}

                        {showClickText && (
                            <p className="card-text">
                                Click this card to continue
                            </p>
                        )}
                    </CardContainer>
                </div>
            ))}
        </>
    );
}

export default MembershipProductOptions;